"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHeight = createHeight;
const events_1 = require("../../../events");
const queries_1 = require("../queries");
function createHeight({ formatNumber }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.height);
    if (event === undefined) {
        return { value: "-" };
    }
    return {
        value: `${formatNumber(event.value)} cm`,
        timestamp: event.timestamp,
        origin: event.origin
    };
}
